/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { list } from '../fn/submitter-users/list';
import { List$Params } from '../fn/submitter-users/list';
import { listFiltered } from '../fn/submitter-users/list-filtered';
import { ListFiltered$Params } from '../fn/submitter-users/list-filtered';
import { UserSearchResultDto } from '../models/user-search-result-dto';

@Injectable({ providedIn: 'root' })
export class SubmitterUsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `submitterUsersControllerList()` */
  static readonly SubmitterUsersControllerListPath = '/users/submitters/programs/{programId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `list()` instead.
   *
   * This method doesn't expect any request body.
   */
  list$Response(
    params: List$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<UserSearchResultDto>>> {
    return list(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `list$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  list(params: List$Params, context?: HttpContext): Observable<Array<UserSearchResultDto>> {
    return this.list$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserSearchResultDto>>): Array<UserSearchResultDto> => r.body)
    );
  }

  /** Path part for operation `submitterUsersControllerListFiltered()` */
  static readonly SubmitterUsersControllerListFilteredPath =
    '/users/submitters/programs/{programId}/filterSubmitterUsers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listFiltered()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listFiltered$Response(
    params: ListFiltered$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<UserSearchResultDto>>> {
    return listFiltered(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listFiltered$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listFiltered(params: ListFiltered$Params, context?: HttpContext): Observable<Array<UserSearchResultDto>> {
    return this.listFiltered$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<UserSearchResultDto>>): Array<UserSearchResultDto> => r.body)
    );
  }
}
